module.exports = __webpack_public_path__ + "img/collection-weddingRingsFinishes@2x.9c6b6cf.jpg";